import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/publicportal/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/home/vsts/work/1/s/publicportal/src/app/app-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/publicportal/src/lib/registry.tsx");
